<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/chats"></ion-back-button>
    </ion-buttons>
    <ion-title>Mimbo Bot</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content color="lightmimbo" class="ion-padding">
  <div class="chat">
    <div *ngFor="let m of messages" class="row" [class.me]="m.role==='user'">
      <div class="bubble">
        <div class="text" [innerHtml]="m.content"></div>
      </div>
    </div>

    <div class="typing" *ngIf="isTyping">
      <span></span><span></span><span></span>
    </div>
  </div>
</ion-content>
<ion-footer>
  <ion-toolbar class="composer">
    <ion-textarea [autoGrow]="true" placeholder="Type a message…" [(ngModel)]="input" (keydown)="onKeydown($event)"
      rows="1">
    </ion-textarea>
    <ion-buttons slot="end">
      <ion-button [disabled]="!input.trim() || sending" (click)="send()">
        <ion-icon slot="icon-only" name="paper-plane-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>